import React from "react";
import PropTypes from "prop-types";

import SVG from "../../../../components/SVG";
import { Button } from "../../../../components/simple";

import { PLATFORMS } from "../platforms";

import styles from "../push-modal.module.scss";

const Google = ({
  selectedPlatform,
  fbData,
  onDownload
  // audienceType,
  // editAudienceHandler,
  // allowEdit
}) => {
  // componentDidMount() {
  //   window.fbAsyncInit = () => {
  //     window.FB.init({
  //       appId: "678360072731073",
  //       autoLogAppEvents: true,
  //       xfbml: true,
  //       version: "v7.0"
  //     });

  //     // Now that we've initialized the JavaScript SDK, we call
  //     // FB.getLoginStatus().  This function gets the state of the
  //     // person visiting this page and can return one of three states to
  //     // the callback you provide.  They can be:
  //     //
  //     // 1. Logged into your app ('connected')
  //     // 2. Logged into Facebook, but not your app ('not_authorized')
  //     // 3. Not logged into Facebook and can't tell if they are logged into
  //     //    your app or not.
  //     //
  //     // These three cases are handled in the callback function.
  //     window.FB.getLoginStatus(response => {
  //       this.statusChangeCallback(response);
  //     });
  //   };

  //   // Load the SDK asynchronously
  //   ((d, s, id) => {
  //     const fjs = d.getElementsByTagName(s)[0];
  //     if (d.getElementById(id)) return;
  //     const js = d.createElement(s);
  //     js.id = id;
  //     js.src = "//connect.facebook.net/en_US/sdk.js";
  //     fjs.parentNode.insertBefore(js, fjs);
  //   })(document, "script", "facebook-jssdk");
  // }

  // testAPI = () => {
  //   console.log("Welcome!  Fetching your information.... ");
  //   window.FB.api("/me", function(response) {
  //     console.log(`Successful login for: ${response.name}`);
  //     console.log(response);
  //   });
  // };

  // // This is called with the results from from FB.getLoginStatus().
  // statusChangeCallback = response => {
  //   console.log("statusChangeCallback");
  //   console.log(response);
  //   // The response object is returned with a status field that lets the
  //   // app know the current login status of the person.
  //   // Full docs on the response object can be found in the documentation
  //   // for FB.getLoginStatus().
  //   if (response.status === "connected") {
  //     // Logged into your app and Facebook.
  //     this.testAPI();
  //   } else if (response.status === "not_authorized") {
  //     // The person is logged into Facebook, but not your app.
  //     console.log("Please log into this app.");
  //   } else {
  //     // The person is not logged into Facebook, so we're not sure if
  //     // they are logged into this app or not.
  //     console.log("Please log into Facebook.");
  //   }
  // };

  // // This function is called when someone finishes with the Login
  // // Button.  See the onlogin handler attached to it in the sample
  // // code below.
  // checkLoginState = () => {
  //   window.FB.getLoginStatus(
  //     function(response) {
  //       this.statusChangeCallback(response);
  //     }.bind(this)
  //   );
  // };

  // handleClick = () => {
  //   window.FB.login(this.checkLoginState(), {
  //     scope: "public_profile"
  //   });
  // };

  return (
    <>
      <div
        className={` ${styles["fb-signin"]} ${
          selectedPlatform === PLATFORMS.google
            ? styles["slide-from-right"]
            : ""
        }`}
      >
        {/* <div className={styles["platform-logo"]}> */}
        {/*  <SVG.Google360 width={34} height={44} /> Display & Video 360 */}
        {/* </div> */}
        <div className={styles["platform-logo"]}>Download .csv file</div>
        {/* <div className={styles["connect-account"]}>Connect Account</div> */}

        {fbData?.accessToken ? (
          <div className={styles["fb-authorized-profile"]}>
            <img src={fbData?.picture?.data?.url} alt="avatar" />
            <span>{fbData?.name}</span>
            <SVG.Tick2 className={styles["fb-authorized-icon"]} />
          </div>
        ) : null}

        <div className={styles["platform-description"]}></div>

        <div className="mt-2">
          <Button
            type="button"
            className={styles["platform-signin-button"]}
            style={{
              width: 186,
              margin: "0 24px 0 0"
            }}
            onClick={() => {
              onDownload();
            }}
          >
            Download CSV
          </Button>
          {/* {audienceType === "audience" && allowEdit && ( */}
          {/*  <Button */}
          {/*    type="button" */}
          {/*    className={`btn btn-secondary ${styles["edit-audience-btn"]}`} */}
          {/*    onClick={editAudienceHandler} */}
          {/*  > */}
          {/*    <span>Edit audience</span> */}
          {/*  </Button> */}
          {/* )} */}
        </div>
      </div>
    </>
  );
};

Google.propTypes = {
  // audienceType: PropTypes.string.isRequired,
  // editAudienceHandler: PropTypes.func.isRequired,
  selectedPlatform: PropTypes.string,
  fbData: PropTypes.shape({
    accessToken: PropTypes.string,
    picture: PropTypes.shape({
      data: PropTypes.shape({ url: PropTypes.string })
    }),
    name: PropTypes.string
  }),
  onDownload: PropTypes.func
  // allowEdit: PropTypes.bool.isRequired
};

Google.defaultProps = {
  selectedPlatform: "",
  fbData: {
    picture: {
      data: { url: "" }
    },
    name: ""
  },
  onDownload: () => {}
};

export default Google;
